import { getSeasonPartitionEventId, MAX_ALLOWED_ACTIVE_SEASON, SeasonPartitionType, TScoringSystem, TSeasonDef } from '../mythicPlus';
import { Expansion, ExpansionPatch } from '../expansion';
import { RealmConnectionType } from '../sharedTypes';
import { FULL_MOMENTO_DATA_PROVIDERS } from '../dataProviders';
import { FAR_FUTURE_DATE } from '../sharedConstants';
import { DRAGON_SOUL_RELEASE_DATES, MISTS_OF_PANDARIA_RAID_RELEASE_DATES, THRONE_OF_THUNDER_RELEASE_DATES } from './dates';

export const SEASONS: TSeasonDef[] = [
  {
    id: 3,
    slug: 'season-mop-2',
    name: 'Season 2',
    short_name: 'MOP2',
    scoringSystem: TScoringSystem.V3,
    title: 'MOP Season 2',
    expansionId: Expansion.MistsOfPandaria,
    assetExpansionId: Expansion.MistsOfPandaria,
    patchId: ExpansionPatch.Patch_520,
    assetPatchId: ExpansionPatch.Patch_520,
    skipAffixAlerts: true,
    icon: 'achievement_challengemode_gold',
    affixThreshold: [],
    blizzardSeasonId: -19,
    isMainSeason: true,
    allowedDungeonPatches: [],
    allowedDungeons: [
      5918, // Shado-Pan Monastery
      5963, // Stormstout Brewery
      5965, // Temple of the Jade Serpent
      5976, // Gate of the Setting Sun
      6052, // Scarlet Halls
      6066, // Scholomance
      6109, // Scarlet Monastery
      6182, // Mogu'shan Palace
      6214 // Siege of Niuzao Temple
    ],
    supportsWarbands: false,
    supportsAffixes: false,
    supportsSpecs: true,
    supportsFactions: true,
    supportsMixedFactions: false,
    supportsTeams: false,
    supportsWeeklies: true,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    supportsReplays: true,
    supportsHeatmap: true,
    loadoutFeatures: ['tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(1, 0)
    },
    allowedRealmTypes: [RealmConnectionType.LIVE],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: THRONE_OF_THUNDER_RELEASE_DATES,
    ends: {
      us: FAR_FUTURE_DATE,
      eu: FAR_FUTURE_DATE,
      tw: FAR_FUTURE_DATE,
      kr: FAR_FUTURE_DATE,
      cn: FAR_FUTURE_DATE
    }
  },
  {
    id: 1,
    slug: 'season-mop-1',
    name: 'Season 1',
    short_name: 'MOP1',
    scoringSystem: TScoringSystem.V3,
    title: 'MOP Season 1',
    expansionId: Expansion.MistsOfPandaria,
    assetExpansionId: Expansion.MistsOfPandaria,
    patchId: ExpansionPatch.Patch_500,
    assetPatchId: ExpansionPatch.Patch_500,
    skipAffixAlerts: true,
    icon: 'achievement_challengemode_gold',
    affixThreshold: [],
    blizzardSeasonId: -20,
    isMainSeason: true,
    allowedDungeonPatches: [],
    allowedDungeons: [
      5918, // Shado-Pan Monastery
      5963, // Stormstout Brewery
      5965, // Temple of the Jade Serpent
      5976, // Gate of the Setting Sun
      6052, // Scarlet Halls
      6066, // Scholomance
      6109, // Scarlet Monastery
      6182, // Mogu'shan Palace
      6214 // Siege of Niuzao Temple
    ],
    supportsWarbands: false,
    supportsAffixes: false,
    supportsSpecs: true,
    supportsFactions: true,
    supportsMixedFactions: false,
    supportsTeams: false,
    supportsWeeklies: true,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    supportsReplays: true,
    supportsHeatmap: true,
    loadoutFeatures: ['tier', 'score'],
    partition: {
      type: SeasonPartitionType.LIVE,
      eventId: getSeasonPartitionEventId(0, 0)
    },
    allowedRealmTypes: [RealmConnectionType.LIVE],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: MISTS_OF_PANDARIA_RAID_RELEASE_DATES,
    ends: THRONE_OF_THUNDER_RELEASE_DATES
  },
  {
    id: 2,
    slug: 'season-mop-1-beta',
    name: 'Season 1 • Beta',
    short_name: 'MOP1BETA',
    scoringSystem: TScoringSystem.V3,
    title: 'MOP Season 1 • Beta',
    expansionId: Expansion.MistsOfPandaria,
    assetExpansionId: Expansion.MistsOfPandaria,
    patchId: ExpansionPatch.Patch_500,
    assetPatchId: ExpansionPatch.Patch_500,
    skipAffixAlerts: true,
    icon: 'achievement_challengemode_gold',
    affixThreshold: [],
    blizzardSeasonId: -20,
    isMainSeason: false,
    allowedDungeonPatches: [],
    allowedDungeons: [
      5918, // Shado-Pan Monastery
      5963, // Stormstout Brewery
      5965, // Temple of the Jade Serpent
      5976, // Gate of the Setting Sun
      6052, // Scarlet Halls
      6066, // Scholomance
      6109, // Scarlet Monastery
      6182, // Mogu'shan Palace
      6214 // Siege of Niuzao Temple
    ],
    supportsWarbands: false,
    supportsAffixes: false,
    supportsSpecs: true,
    supportsFactions: true,
    supportsMixedFactions: false,
    supportsTeams: false,
    supportsWeeklies: true,
    supportsCovenants: false,
    supportsRunRaceAndItemLevel: true,
    supportsScoreStats: true,
    supportsCutoffsPage: false,
    supportsRecruitment: false,
    supportsRouteGeneration: true,
    supportsReplays: true,
    supportsHeatmap: true,
    loadoutFeatures: ['tier', 'score'],
    partition: {
      type: SeasonPartitionType.BETA,
      eventId: getSeasonPartitionEventId(0, 1)
    },
    allowedRealmTypes: [RealmConnectionType.BETA],
    dataProviders: FULL_MOMENTO_DATA_PROVIDERS,
    starts: DRAGON_SOUL_RELEASE_DATES, // will need to be updated
    ends: MISTS_OF_PANDARIA_RAID_RELEASE_DATES
  },
];

export const SEASONS_BY_SLUG = new Map<string, TSeasonDef>(SEASONS.map((season: TSeasonDef) => [season.slug, season]));

// Safety check
{
  const activeSeasons = SEASONS.filter((s) => s.ends.us === FAR_FUTURE_DATE && s.starts.us !== FAR_FUTURE_DATE).length;
  if (activeSeasons > MAX_ALLOWED_ACTIVE_SEASON) {
    throw new Error(
      `There's ${activeSeasons} active seasons where a maximum of ${MAX_ALLOWED_ACTIVE_SEASON} is required.`
    );
  }

  const partitionIds = new Set<number>();
  const seasonIds = new Set<number>();
  SEASONS.forEach((s) => {
    if (seasonIds.has(s.id)) {
      throw new Error(`There's already a season using this id #${s.id}. Found duplicate in ${s.name}`);
    }
    seasonIds.add(s.id);

    if (s.partition?.eventId) {
      if (partitionIds.has(s.partition.eventId)) {
        throw new Error(
          `There's already a season using this eventid #${s.partition.eventId}. Found duplicate in ${s.name}`
        );
      }

      partitionIds.add(s.partition.eventId);
    }
  });
}
